export default __webpack_public_path__ + "static/media/alert-danger-variation.50d7bdf6.svg";